export const isValidDate = (date: any): any => {
  if (!date) {
    return date;
  }

  return Object.prototype.toString.call(date) === '[object Date]';
};
